<template>
  <div>
    <Modal v-model="modal" :title="!mailboxWarningForm.id ? this.$t('alarms.mailbox.addMailBoxAlarm'):this.$t('alarms.mailbox.editMailBoxAlarm')" :loading="loading" :mask-closable="false" :styles="{top:'65px'}" width="800px" :closable="false">
      <Form ref="mailboxWarningForm" :model="mailboxWarningForm" :label-width="110" :rules="ruleValidate">
        <!-- 微信警告 -->
        <wechat-warning v-if="wechatWarningVisible" ref="wechatWarning"></wechat-warning>
        <!-- 规则名称 -->
        <FormItem :label="$t('alarms.common.ruleName')" prop="ruleName" v-if="isEditRuleName">
          <Row>
            <Col span="11">
              <Input type="text" v-model="mailboxWarningForm.ruleName" placeholder="Enter something..."
                     style="width:300px;" :disabled="isEdit"></Input>
            </Col>
          </Row>
        </FormItem>

        <!-- 规则名称 -->
        <FormItem :label="$t('alarms.common.ruleName')" v-if="showRuleName">
          <Row >
            <Col span="24">
              <div>{{this.mailboxWarningForm.ruleName}}</div>
            </Col>
          </Row>
        </FormItem>

        <!-- 账户 -->
        <FormItem :label="$t('alarms.common.account')" prop="account">
          <Select v-model="mailboxWarningForm.account" :transfer="true" style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
            <Option :value="item.id" v-for="(item,index) in accountList" v-bind:key="index">{{item.name}}</Option>
          </Select>
        </FormItem>

        <!-- 监控邮箱 -->
        <FormItem :label="$t('alarms.mailbox.monitoringMailBox')" prop="monitorMailboxs">
          <Select @on-change="changeMonitorMailbox"
                  v-model="mailboxWarningForm.monitorMailboxs" multiple :max-tag-count="1" :transfer="true" style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
            <Checkbox v-model="singleMonitorMailbox" @on-change="selectMonitorMailboxAll"
                      style="display: block;text-align:right;">
              {{ $t('alarms.common.allSelected') }}
            </Checkbox>
            <Option :value="item.id" v-for="item in monitorMailboxList" :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>

        <!-- 规则描述 -->
        <FormItem :label="$t('alarms.common.ruleDescription')">
          <Row :gutter="4">
            <!-- 监控指标 -->
            <Col span="6">
              <FormItem prop="monitorIndex">
                <Select v-model="mailboxWarningForm.monitorIndex" @on-change="changeMonitorIndex(mailboxWarningForm.monitorIndex)" :placeholder="$t('alarms.common.pleaseSelect')">
                  <Option :value="item.id" v-for="item in monitorIndexList" :key="item.id">{{item.name}}</Option>
                </Select>
              </FormItem>
            </Col>
            <!-- 周期 -->
            <Col span="3">
              <FormItem prop="cycle">
                <Select v-model="mailboxWarningForm.cycle" :placeholder="$t('alarms.common.cycle')"
                        @on-change="changeCycle(mailboxWarningForm.cycle)">
                  <Option :value="item.id" v-for="(item,index) in cycleList" v-bind:key="index">{{item.name}}</Option>
                </Select>
              </FormItem>
            </Col>
            <!-- 连续周期 -->
            <Col span="4">
              <FormItem prop="continousCycle">
                <Select v-model="mailboxWarningForm.continousCycle" :placeholder="$t('alarms.common.continuousCycle')"
                        @on-change="changeContinousCycle(mailboxWarningForm.continousCycle)">
                  <Option :value="item.id" v-for="(item,index) in continousCycleList" v-bind:key="index">{{item.name}}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <!-- 统计数值 -->
            <Col span="4">
              <FormItem prop="statisticsValue">
                <Select v-model="mailboxWarningForm.statisticsValue" :placeholder="$t('alarms.common.continuousCycle')"
                        @on-change="changeStatisticsValue(mailboxWarningForm.statisticsValue)">
                  <Option :value="item.id" v-for="(item,index) in statisticsValueList" v-bind:key="index">
                    {{item.name}}
                  </Option>
                </Select>
              </FormItem>
            </Col>


            <!-- 如果监控指标为Mailbox时 不显示符号、阈值和单位 -->
            <div v-if="this.isShowField!=1">
              <!-- 关系符号 -->
              <Col span="2">
                <FormItem prop="relationshipSign">
                  <Select v-model="mailboxWarningForm.relationshipSign"
                          @on-change="changeRelationshipSign(mailboxWarningForm.relationshipSign)" :placeholder="$t('alarms.common.symbol')">
                    <Option :value="item.id" v-for="(item,index) in relationshipSignList" v-bind:key="index">
                      {{item.name}}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 阈值 -->
              <Col span="2">
                <FormItem prop="thresholdValue">
                  <Input v-model="mailboxWarningForm.thresholdValue" :placeholder="$t('alarms.common.threshold')"></Input>
                </FormItem>
              </Col>
              <!-- 单位 -->
              <Col span="2">
                <FormItem prop="unit">
                  <Input v-model="mailboxWarningForm.unit" disabled :placeholder="$t('alarms.common.unit')"></Input>
                </FormItem>
              </Col>
            </div>
            <div v-else-if="this.isShowField==2">
              <!-- 关系符号 -->
              <Col span="2">
                <FormItem prop="relationshipSign">
                  <Select v-model="mailboxWarningForm.relationshipSign"
                          @on-change="changeRelationshipSign(mailboxWarningForm.relationshipSign)" :placeholder="$t('alarms.common.symbol')">
                    <Option :value="item.id" v-for="(item,index) in relationshipSignList" v-bind:key="index">
                      {{item.name}}
                    </Option>
                  </Select>
                </FormItem>
              </Col>
              <!-- 阈值 -->
              <Col span="2">
                <FormItem prop="thresholdValue">
                  <Input v-model="mailboxWarningForm.thresholdValue" :placeholder="$t('alarms.common.threshold')" type="number"></Input>
                </FormItem>
              </Col>
              <!-- 单位 -->
              <Col span="2">
                <FormItem prop="unit">
                  <Input v-model="mailboxWarningForm.unit" disabled :placeholder="$t('alarms.common.unit')"></Input>
                </FormItem>
              </Col>
            </div>
          </Row>
        </FormItem>

        <!-- 联系方式 -->
        <FormItem :label="$t('alarms.common.contactType')" prop="contactType">
          <RadioGroup v-model="mailboxWarningForm.contactType" @on-change="changeContactType(mailboxWarningForm.contactType)">
            <Radio v-for="item in contactTypeList" :label="item.type" :key="item.value">{{item.label}}</Radio>
          </RadioGroup>
        </FormItem>

        <!-- 通知对象 -->
        <FormItem :label="$t('alarms.common.notificationObject')" prop="notificationObject" v-if="mailboxWarningForm.contactType==0">
          <Select v-model="mailboxWarningForm.notificationObject" multiple style="width:300px;" @on-change="changeNotificationObject" :placeholder="$t('alarms.common.pleaseSelect')">
            <Option v-for="item in notificationObjectList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>

        <!-- 联系人组 -->
        <FormItem :label="$t('alarms.common.contactGroup')" prop="contactGroupIds" v-if="mailboxWarningForm.contactType==1">
          <Select v-model="mailboxWarningForm.contactGroupIds" multiple style="width:300px;" @on-change="changeContactGroupId(mailboxWarningForm.contactGroupIds)" :placeholder="$t('alarms.common.pleaseSelect')">
            <Option v-for="item in contactGroupIdList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>

        <!-- 报警方式 -->
        <FormItem :label="$t('alarms.common.noticeType')" prop="noticeType">
          <Select v-model="mailboxWarningForm.noticeType" multiple style="width:300px;"
                  @on-change="selectNoticeType(mailboxWarningForm.noticeType)" :placeholder="$t('alarms.common.pleaseSelect')">
            <Option v-for="item in alarmWayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>

        <!-- 企业微信机器人URL -->
        <FormItem :label="$t('alarms.common.enterpriseWeChatRobotURL')" prop="enterpriseWechatRobotIds" v-if="mailboxWarningForm.noticeType.filter(function (e) { return e == 3; }).length != 0">
          <Select v-model="mailboxWarningForm.enterpriseWechatRobotIds" multiple style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
            <Option v-for="item in enterpriseWechatRobotIdsList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>

        <!-- 延迟告警 -->
        <FormItem :label="$t('alarms.common.alarmDelay')" prop="alarmDelay">
          <Select v-model="mailboxWarningForm.alarmDelay" style="width:300px;" :placeholder="$t('alarms.common.pleaseSelect')">
            <Option v-for="item in alarmDelayList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>

        <!-- 邮箱模板 -->
        <div v-show="isShowEmail">
          <FormItem :label="$t('alarms.common.emailModal')" prop="emailModal">
            <Input v-model="mailboxWarningForm.emailModal" type="textarea"
                   :autosize="{minRows: 2,maxRows: 5}" style="width:665px;" disabled></Input>
          </FormItem>
        </div>

        <!-- 企业微信模板 -->
        <div v-show="isShowWeChat">
          <FormItem :label="$t('alarms.common.wechatModal')" prop="wechatModal">
            <Input v-model="mailboxWarningForm.wechatModal" type="textarea"
                   :autosize="{minRows: 2,maxRows: 5}" style="width:665px;" disabled></Input>
          </FormItem>
        </div>
      </Form>
      <div slot="footer">
          <Button size="large" @click="cancel('mailboxWarningForm')">{{ $t('alarms.common.cancel') }}</Button>
          <Button type="primary" size="large" @click="ok('mailboxWarningForm')" :loading="addloading" :disabled="isAddOrEdit">
            {{!mailboxWarningForm.id ? this.$t('common.addAlarm'):this.$t('common.editAlarm')}}
          </Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import WechatWarning from '../../common/WechatWarning.vue'
  import {setCookie, getCookie} from '../../../../utils/cookieUtil.js'
  import TableMailboxWarning from './TableMailboxWarning.vue'

  var tableMailboxWarning = TableMailboxWarning;
  var tableMailboxWarningVue = {}
  export default {
    inject: ['reload'],
    components: {
        WechatWarning
    },
    data() {
      // 名字是否重复
      var validNameRepeatedCheck = (rule, value, callback) => {
        var self = this;
        self.$api.alertRule.nameRepeatedCheck({
          "alertRuleName": this.mailboxWarningForm.ruleName,
          "monitorModule": this.monitorModule
        })
          .then(res => {
            if (res.status == 200) {
              callback();
            }
          })
          .catch(err => {
            if (err.status == 400) {
              callback(new Error(this.$t('monitor.alarmRule.ruleNameRepeated')));
            }
          })
      };
      return {
        addloading:false,
        isAddOrEdit:true,
        wechatWarningVisible: false,
          contactTypeList: [{
              label: this.$t('alarms.common.contactPerson'),
              value: 'contact',
              type: 0
          },
              {
                  label: this.$t('alarms.common.contactGroup'),
                  value: 'contactGroup',
                  type: 1
              }],
        isShowField: '', //是否显示符号、阈值和单位
        singleMonitorMailbox: false,
        alarmDelayList: [],
        isEdit: false,
        isEditRuleName: false,
        showRuleName: false,
        isShowEmail: false,
        isShowWeChat: false,
        accountList: [],
        notificationObjectList: [],
        alarmWayList: [],
        monitorMailboxList: [],
        loading: true,
        modal: false,
        modal_loading: false,
        exportDataList: '',
        noticeType: [],
        units: '',
        unit: '',
        monitorModule: 34,
        mailboxWarningForm: {
          account: '',
          monitorMailboxs: [],
          ruleName: '',
          notificationObject: [],
          noticeType: [],
          emailModal: '',
          wechatModal: '',
          thresholdValue: '',
          monitorIndex: '',
          cycle: '',
          continousCycle: '',
          statisticsValue: '',
          relationshipSign: '',
          unit: '',
          alarmDelay: '',
          contactType: 0,
          contactGroupIds: [],
          userIdList:[],
          enterpriseWechatRobotIds:[]
        },
        enterpriseWechatRobotIdsList:[],
        // 联系人组
        contactGroupIdList: [],
        // 监控指标
        monitorIndexList: [],
        // 周期
        cycleList: [],
        // 连续周期
        continousCycleList: [],
        // 统计数值
        statisticsValueList: [],
        // 关系符号
        relationshipSignList: [],
        ruleValidate: {
          account: [
            {required: true, message: this.$t('monitor.alarmRule.accountRequired'), trigger: 'change', type: 'number'}
          ],
          alarmDelay: [
            {required: true, message: this.$t('monitor.alarmRule.alarmDelayRequired'), trigger: 'change', type: 'number'}
          ],
          monitorMailboxs: [
            {required: true, type: 'array', message: this.$t('alarms.mailbox.selectMailbox'), trigger: 'change'}
          ],
          ruleName: [
            {required: true, message: this.$t('monitor.alarmRule.ruleNameRequired'), trigger: 'blur'},
            {type: 'string', message: this.$t('monitor.alarmRule.ruleNamePattern'), pattern: '^[^ ]{2,20}$', trigger: 'blur'},
            {validator: validNameRepeatedCheck, trigger: 'blur'}
          ],
          notificationObject: [
            {required: true, type: 'array', message: this.$t('monitor.alarmRule.notificationObjectRequired'), trigger: 'change'}
          ],
          noticeType: [
            {required: true, type: 'array', min: 1, message: this.$t('monitor.alarmRule.noticeTypeRequired'), trigger: 'change'}
          ],
          monitorIndex: [
            {required: true, message: this.$t('monitor.alarmRule.monitorIndexRequired'), trigger: 'change', type: 'number'}
          ],
          cycle: [
            {required: true, message: this.$t('monitor.alarmRule.cycleRequired'), trigger: 'change', type: 'number'}
          ],
          continousCycle: [
            {required: true, message: this.$t('monitor.alarmRule.continousCycleRequired'), trigger: 'change', type: 'number'}
          ],
          statisticsValue: [
            {required: true, message: this.$t('monitor.alarmRule.statisticsValueRequired'), trigger: 'change', type: 'number'}
          ],
          relationshipSign: [
            {required: true, message: this.$t('monitor.alarmRule.relationshipSignRequired'), trigger: 'change', type: 'number'}
          ],
          thresholdValue: [
            {required: true, message: this.$t('monitor.alarmRule.thresholdRequired')}
          ],
          contactType: [
            {required: true, message: this.$t('monitor.alarmRule.contactTypeRequired'), trigger: 'change', type: 'number'}
          ],
          contactGroupIds: [
            {required: true, message: this.$t('monitor.alarmRule.contactGroupRequired'), trigger: 'change', type: 'array'}
          ],
          enterpriseWechatRobotIds: [
            {required: true, type: 'array', message: this.$t('monitor.alarmRule.enterpriseWechatRobotRequired'), trigger: 'change'}
          ]
        }
      }
    },

    beforeCreate: function () {
      tableMailboxWarningVue = this
    },
    methods: {
      //显示表格数据
      /****************************************************************/
      init: function (id) {
        this.mailboxWarningForm.id = id || 0;
        // 根据用户名查询Account列表
        tableMailboxWarningVue.queryMailboxByUserName();
        this.$nextTick(() => {
          // 重置表单
          this.$refs['mailboxWarningForm'].resetFields();
          // 编辑
          if (this.mailboxWarningForm.id) {
            // 编辑显示不能输入的规则名称
            this.showRuleName = true;
            this.isEdit = true;
            this.$api.alertRule.selectAlertRule("id", this.mailboxWarningForm.id)
              .then(res => {
                //账号
                this.mailboxWarningForm.account = res.data.accountId;
                //延时
                this.mailboxWarningForm.alarmDelay = res.data.delay;
                // 邮箱
                this.mailboxWarningForm.monitorMailboxs = res.data.monitorMailboxs;

                // 规则名称
                this.mailboxWarningForm.ruleName = res.data.alertRuleName;

                // 监控指标
                /******************************************************/
                // 查询监控指标
                tableMailboxWarningVue.$api.alertRule.searchDefaultMonitorIndex(
                  "monitorModule", this.monitorModule
                )
                  .then(res => {
                    this.monitorIndexList = res.data;
                  })
                this.mailboxWarningForm.monitorIndex = res.data.monitorIndex;
                // 如果监控指标为Mailbox时 不显示符号、阈值和单位
                if (this.mailboxWarningForm.monitorIndex == 55) {
                  this.isShowField = 1;
                } else {
                  this.isShowField = 2;
                }

                // 周期
                this.mailboxWarningForm.cycle = res.data.cycle;
                // 连续周期
                this.mailboxWarningForm.continousCycle = res.data.continousCycle;
                // 统计数值
                this.mailboxWarningForm.statisticsValue = res.data.statisticsValue;
                // 符号
                this.mailboxWarningForm.relationshipSign = res.data.relationshipSign;
                // 阈值
                this.mailboxWarningForm.thresholdValue = res.data.thresholdStringValue;
                // 单位
                this.mailboxWarningForm.unit = res.data.unit;
                this.units = res.data.unitId;
                // 企业微信机器人URL
                this.mailboxWarningForm.enterpriseWechatRobotIds=res.data.enterpriseWechatRobotIds;

                // 联系方式
                this.mailboxWarningForm.contactType = res.data.contactType;
                if (res.data.contactType == 0) {
                  // 通知对象
                  this.mailboxWarningForm.notificationObject = res.data.contactIDs;
                  for(var i=0;i<this.mailboxWarningForm.notificationObject.length;i++){
                    for(var j=0;j<this.notificationObjectList.length;j++){
                      if(this.mailboxWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
                         this.mailboxWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
                      }
                    }
                  }
                } else if (res.data.contactType == 1) {
                  // 联系人组
                  this.$api.contactGroup.listContactGroups()
                    .then(res => {
                      this.contactGroupIdList = res.data;
                    })
                  setTimeout(() => {
                    this.mailboxWarningForm.contactGroupIds = res.data.contactGroupIds;
                  }, 1000)
                }

                // 查询阈值
                tableMailboxWarningVue.selectMonitorIndexDefault();

                // 报警方式
                this.mailboxWarningForm.noticeType = res.data.noticeType;

                for (var i = 0; i < this.mailboxWarningForm.noticeType.length; i++) {
                  if (this.mailboxWarningForm.noticeType[i] == '0') {
                    this.isShowEmail = true;
                    this.mailboxWarningForm.emailModal = res.data.briefReportBodyMail;
                    this.noticeType = this.mailboxWarningForm.noticeType;
                    tableMailboxWarningVue.selectTemplate();
                  }
                  if (this.mailboxWarningForm.noticeType[i] == '1') {
                    // this.isShowWeChat = true;
                    this.mailboxWarningForm.wechatModal = res.data.briefReportBodyWechat;
                    this.checkLeastOnePersonBoundWeChat();
                    this.noticeType = this.mailboxWarningForm.noticeType;
                    tableMailboxWarningVue.selectTemplate();
                  }else if(this.mailboxWarningForm.noticeType[i]!='1'){
                    this.wechatWarningVisible=false;
                    this.isAddOrEdit=false;
                  }
                }
              })
          } else {
            this.isEdit = false;
            // 添加显示规则名称能输入
            this.isEditRuleName = true;
            this.showRuleName = false;
          }
        })
        this.modal = true;
      },
      // 根据监控指标 显示不同单位
      /****************************************************************/
      // 清空周期、连续周期、统计数值、关系符号
      emptyDate: function () {
        this.mailboxWarningForm.cycle = '';
        this.mailboxWarningForm.continousCycle = '';
        this.mailboxWarningForm.statisticsValue = '';
        this.mailboxWarningForm.relationshipSign = '';
        this.mailboxWarningForm.thresholdValue = '';
      },
      isNotEmpty: function (obj) {
        if (typeof obj === "undefined" || obj === null || obj === "") {
          return false;
        } else {
          return true;
        }
      },
      // 根据监控指标 显示不同单位
      changeMonitorIndex: function () {
        // 如果监控指标为Mailbox时 不显示符号、阈值和单位
        if (this.mailboxWarningForm.monitorIndex == 55) {
          this.isShowField = 1;
        } else {
          this.isShowField = 2;
        }
        tableMailboxWarningVue.selectMonitorIndexDefault();
        this.unit = this.mailboxWarningForm.monitorIndex;
        for (var i = 0; i < this.monitorIndexList.length; i++) {
          if (this.monitorIndexList[i].id == this.unit) {
            this.mailboxWarningForm.unit = this.monitorIndexList[i].unit;
            this.units = this.monitorIndexList[i].id;
          }
        }
        tableMailboxWarningVue.selectTemplate();
        tableMailboxWarningVue.emptyDate();
      },
      // 查询阈值
      /****************************************************************/
      selectMonitorIndexDefault: function () {
        tableMailboxWarningVue.$api.alertRule.selectMonitorIndexDefault({
          "monitorIndex": this.mailboxWarningForm.monitorIndex,
          "monitorModule": this.monitorModule,
          "cycle": this.mailboxWarningForm.cycle,
          "continousCycle": this.mailboxWarningForm.continousCycle,
          "statisticsValue": this.mailboxWarningForm.statisticsValue,
          "relationshipSign": this.mailboxWarningForm.relationshipSign
        })
          .then(res => {
            // 周期
            this.cycleList = res.data.cycleMap;
            // 连续周期
            this.continousCycleList = res.data.continousCycleMap;
            // 统计数值
            this.statisticsValueList = res.data.statisticsValueMap;
            // 关系符号
            this.relationshipSignList = res.data.relationshipSignMap;
            // 阈值
            if (res.data.companyMonitoritemVariablesList.length == 1 && tableMailboxWarningVue.isNotEmpty(this.mailboxWarningForm.cycle) && tableMailboxWarningVue.isNotEmpty(this.mailboxWarningForm.continousCycle) && tableMailboxWarningVue.isNotEmpty(this.mailboxWarningForm.statisticsValue) && tableMailboxWarningVue.isNotEmpty(this.mailboxWarningForm.relationshipSign) && this.mailboxWarningForm.id == 0) {
              this.mailboxWarningForm.thresholdValue = res.data.companyMonitoritemVariablesList[0].customerMonitorIndexDefaultValue;
            }

          })
      },
      // 查询邮件模板
      /****************************************************************/
      selectTemplate: function () {
        tableMailboxWarningVue.$api.briefReport.selectTemplate({
          "monitorIndex": this.mailboxWarningForm.monitorIndex,
          "relationshipSign": this.mailboxWarningForm.relationshipSign,
          "monitorModule": this.monitorModule,
          "noticeType": this.mailboxWarningForm.noticeType
        })
          .then(res => {
            this.mailboxWarningForm.wechatModal = res.data.briefReportBodyWechat;
            this.mailboxWarningForm.emailModal = res.data.briefReportBodyMail;
          })
      },
      //报警方式为邮箱显示邮箱模板  为企业微信显示企业微信模板
      selectNoticeType: function () {
        this.isShowEmail = false;
        this.isShowWeChat = false;
        for (var i = 0; i < this.mailboxWarningForm.noticeType.length; i++) {
          if (this.mailboxWarningForm.noticeType[i] == '0') {
            this.isShowEmail = true;
            this.noticeType = this.mailboxWarningForm.noticeType;
            tableMailboxWarningVue.selectTemplate();
          }
          if (this.mailboxWarningForm.noticeType[i] == '1') {
            // this.isShowWeChat = true;
            this.noticeType = this.mailboxWarningForm.noticeType;
            this.checkLeastOnePersonBoundWeChat();
            tableMailboxWarningVue.selectTemplate();
          }else if(this.mailboxWarningForm.noticeType[i]!='1'){
              this.wechatWarningVisible=false;
              this.isAddOrEdit=false;
          }
        }
      },
      // 检查至少有一人绑定过微信
      checkLeastOnePersonBoundWeChat:function(){
        for(var i=0;i<this.mailboxWarningForm.noticeType.length;i++){
            if(this.mailboxWarningForm.noticeType[i]==1){
                var weChatDate={
                    "contactType":this.mailboxWarningForm.contactType
                };
                // 联系方式为 -联系人-
                if(this.mailboxWarningForm.contactType==0){
                    weChatDate.userIds=this.mailboxWarningForm.userIdList;
                }
                // 联系方式为 -联系人组-
                else if(this.mailboxWarningForm.contactType==1){
                    weChatDate.contactGroupIds = this.mailboxWarningForm.contactGroupIds;
                }
                this.$api.userWeChat.checkLeastOnePersonBoundWeChat(weChatDate)
                .then(res => {
                    if(res.data){
                      // 可以添加告警
                      this.wechatWarningVisible=false;
                      this.isAddOrEdit=false;
                    }else{
                      // 不可以添加微信告警
                      this.wechatWarningVisible=true;
                      this.isAddOrEdit=true;
                    }
                })
            }else if(this.mailboxWarningForm.noticeType[i]!=1){
                this.wechatWarningVisible=false;
                this.isAddOrEdit=false;
            }
        }
      },
      // 联系人组
      listContactGroups:function(){
          this.$api.contactGroup.listContactGroups()
          .then(res => {
              this.contactGroupIdList = res.data;
          })
      },
      // 切换联系人组
      changeContactGroupId:function(){
         this.checkLeastOnePersonBoundWeChat();
      },
      // 切换通知对象
      changeNotificationObject:function(val){
        this.mailboxWarningForm.userIdList=[];
        this.mailboxWarningForm.notificationObject=val;
        for(var i=0;i<this.mailboxWarningForm.notificationObject.length;i++){
          for(var j=0;j<this.notificationObjectList.length;j++){
            if(this.mailboxWarningForm.notificationObject[i]==this.notificationObjectList[j].id){
               this.mailboxWarningForm.userIdList.push(this.notificationObjectList[j].userId); //传值
            }
          }
        }
        this.checkLeastOnePersonBoundWeChat();
      },
      // 切换联系方式
      changeContactType:function(){
        this.checkLeastOnePersonBoundWeChat();
      },
      /**************************************  查询  **************************************/
      // 查询监控指标
      searchMonitorIndex: function () {
        tableMailboxWarningVue.$api.alertRule.searchDefaultMonitorIndex(
          "monitorModule", this.monitorModule
        )
          .then(res => {
            this.monitorIndexList = res.data;
          })
      },
      // 查询通知对象
      queryContacts: function () {
        tableMailboxWarningVue.$api.contact.queryContacts("monitorModule", this.monitorModule)
          .then(res => {
            this.notificationObjectList = res.data.contactList;
            this.mailboxWarningForm.notificationObject = res.data.defaultContactIds;
          })
      },
      // 查询报警方式
      alarmWay: function () {
        tableMailboxWarningVue.$api.alertRule.alarmWay("userName", getCookie(global.cookieName))
          .then(res => {
            this.alarmWayList = res.data;
          })
      },
      // 查询报警延迟
      getAlarmDelay: function () {
        tableMailboxWarningVue.$api.alertRule.alarmDelay("userName", getCookie(global.cookieName))
          .then(res => {
            this.alarmDelayList = res.data;
          })
      },
      // 周期
      changeCycle: function () {
        // 查询阈值
        tableMailboxWarningVue.selectMonitorIndexDefault();
      },
      // 连续周期
      changeContinousCycle: function () {
        // 查询阈值
        tableMailboxWarningVue.selectMonitorIndexDefault();
      },
      // 统计数值
      changeStatisticsValue: function () {
        // 查询阈值
        tableMailboxWarningVue.selectMonitorIndexDefault();
      },
      // 关系符号
      changeRelationshipSign: function () {
        // 查询阈值
        tableMailboxWarningVue.selectMonitorIndexDefault();
        // 邮件模板
        tableMailboxWarningVue.selectTemplate();
      },
      // 根据用户名查询Account列表
      queryMailboxByUserName: function () {
        // 清空表格
        tableMailboxWarningVue.$api.mailbox.queryMailboxByUserName()
          .then(res => {
            this.monitorMailboxList = res.data;
          })
        // 查询联系人组
        tableMailboxWarningVue.listContactGroups();
        // 查询账号
        tableMailboxWarningVue.getAccount();
        // 查询规则描述
        tableMailboxWarningVue.searchMonitorIndex();
        // 查询通知对象
        tableMailboxWarningVue.queryContacts();
        // 查询方式
        tableMailboxWarningVue.alarmWay();
        // 查询报警延时
        tableMailboxWarningVue.getAlarmDelay();
        // 监控模块查询关联的机器人列表
        tableMailboxWarningVue.listEnterpriseWechatRobotsByMonitorModule();
      },
      // 监控模块查询关联的机器人列表
      listEnterpriseWechatRobotsByMonitorModule:function(){
          tableMailboxWarningVue.$api.enterpriseWechatRobot.listEnterpriseWechatRobotsByMonitorModule({
                "monitorModule":this.monitorModule
            })
            .then(res => {
                this.enterpriseWechatRobotIdsList = res.data;
            })
      },
      getAccount: function () {
        // 清空表格
        this.$api.account.queryAWSAccounts("userName", getCookie(global.cookieName))
          .then(res => {
            this.accountList = res.data;
            for (var i = 0; i < this.accountList.length; i++) {
              this.accountList[i].name = this.accountList[i].name + '(' + this.accountList[i].accountTypeName + ')';
            }
          })
      },
      /***********邮箱**************************/
      selectMonitorMailboxAll() {
        this.mailboxWarningForm.monitorMailboxs = []
        if (this.singleMonitorMailbox) {
          this.monitorMailboxList.map((item) => {
            this.mailboxWarningForm.monitorMailboxs.push(item.id)
          })
        } else {
          this.mailboxWarningForm.monitorMailboxs = []
        }
      },
      // 切换邮箱
      changeMonitorMailbox: function (val) {
        if (val.length === this.monitorMailboxList.length && val.length != 0) {
          this.singleMonitorMailbox = true
        } else {
          this.singleMonitorMailbox = false
        }
      },
      // 创建添加或编辑报警
      /**********************************************************************************/
      ok: function (name) {
        this.$refs[name].validate(valid => {
          if (valid) {
            var alertList = {
              "alertRuleName": this.mailboxWarningForm.ruleName,
              "monitorIndex": this.mailboxWarningForm.monitorIndex,
              "accountId": this.mailboxWarningForm.account,
              "cycle": this.mailboxWarningForm.cycle,
              "continousCycle": this.mailboxWarningForm.continousCycle,
              "statisticsValue": this.mailboxWarningForm.statisticsValue,
              "relationshipSign": this.mailboxWarningForm.relationshipSign,
              "monitorMailboxs": this.mailboxWarningForm.monitorMailboxs,
              "monitorModule": this.monitorModule,
              "noticeType": this.mailboxWarningForm.noticeType,
              "unit": this.units,
              "delay": this.mailboxWarningForm.alarmDelay,
              "thresholdStringValue": this.mailboxWarningForm.thresholdValue,
              "contactType": this.mailboxWarningForm.contactType,
              "enterpriseWechatRobotIds":this.mailboxWarningForm.enterpriseWechatRobotIds
            };

            // 如果联系方式是联系人 传通知对象
            if (this.mailboxWarningForm.contactType == 0) {
              alertList.contactIDs = this.mailboxWarningForm.notificationObject;
            }
            // 如果联系方式是联系人组 传联系人组
            else if (this.mailboxWarningForm.contactType == 1) {
              alertList.contactGroupIds = this.mailboxWarningForm.contactGroupIds;
            }

            if (this.mailboxWarningForm.id > 0) {
              alertList.id = this.mailboxWarningForm.id;
              // 编辑告警
              this.addloading=true;
              tableMailboxWarningVue.$api.alertRule.updateAlertRule(alertList)
                .then(res => {
                  this.data = res.data;
                  setTimeout(() => {
                    this.reload();
                    this.mailboxWarningForm.notificationObject = [];
                    this.$refs[name].resetFields();
                    this.loading = false;
                    this.$nextTick(() => {
                      this.loading = true;
                    });
                    this.$Message.success(this.$t('common.editSuccess'));
                    this.isShowEmail = false;
                    this.isShowWeChat = false;
                    this.addloading=false;
                    this.modal = false;
                    this.wechatWarningVisible=false;
                    this.isAddOrEdit=true;
                  }, 1000);
                })
            } else {
              // 添加告警
              this.addloading=true;
              tableMailboxWarningVue.$api.alertRule.createAlertRule(alertList)
                .then(res => {
                  this.data = res.data;
                  setTimeout(() => {
                    this.reload();
                    this.mailboxWarningForm.notificationObject = [];
                    this.$refs[name].resetFields();
                    this.loading = false;
                    this.$nextTick(() => {
                      this.loading = true;
                    });
                    this.$Message.success(this.$t('common.addSuccess'));
                    this.monitorIndexList = [];
                    this.isShowEmail = false;
                    this.isShowWeChat = false;
                    this.addloading=false;
                    this.modal = false;
                    this.wechatWarningVisible=false;
                    this.isAddOrEdit=true;
                  }, 1000);
                })
            }
          } else {
            //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
            this.loading = false;
            setTimeout(() => {
              this.loading = true
            }, 0)
            if (this.mailboxWarningForm.id > 0) {
              this.$Message.error(this.$t('common.editFail'));
            } else {
              this.$Message.error(this.$t('common.addFail'));
            }
          }
        });
      },
      // 取消
      cancel: function (name) {
        this.wechatWarningVisible=false;
        this.isAddOrEdit=true;
        this.isShowEmail = false;
        this.isShowWeChat = false;
        this.mailboxWarningForm.notificationObject = [];
        this.monitorIndexList = [];
        this.$nextTick(() => {
          this.$refs[name].resetFields();
        });
        this.modal = false;
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/monitor/non_cloud_resources/mailbox/AddOrUpdateMailboxWarning.vue